(() => {
  if (window.galixFooterSky) return;
  const selector = '[data-footer-sky]';
  function init(footer) {
    if (footer.galixSkyController) return;
    const controller = new AbortController(), { signal } = controller;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    footer.galixSkyController = controller;
    footer.dataset.skyReady = 'true';
    function sync() {
      footer.dataset.skyPlaying = String(visible && !reduced.matches && !document.hidden);
    }
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0 });
    observer.observe(footer);
    reduced.addEventListener('change', sync, { signal });
    document.addEventListener('visibilitychange', sync, { signal });
    signal.addEventListener('abort', () => {
      observer.disconnect();
      footer.dataset.skyPlaying = 'false';
      delete footer.dataset.skyReady;
      delete footer.galixSkyController;
    }, { once: true });
    sync();
  }
  function mount(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  window.galixFooterSky = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.(selector)) event.target.galixSkyController?.abort();
    event.target.querySelectorAll(selector).forEach(footer => footer.galixSkyController?.abort());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();
